app.service("geolocation", function (modal, loading, cookie, console) {
	var options = {
		enableHighAccuracy: true,
		maximumAge: 60000,
		timeout: 20000
	};
	var geolocationSuccess, errorCallback;

	function findPosition(callback, error) {
		geolocationSuccess = function (position) {
			let result = {
				latitude: position.coords.latitude,
				longitude: position.coords.longitude
			}
			if (cookie.get('atrUser') == 'js') {			// testy ATR mają ustaloną jedną stałą lokalizację aby zwracały te same dane
				result.latitude = 52.2296756;
				result.longitude = 21.0122287;
			}
			console.log('Geolokalizacja', result);
			callback(result);
			//loading.stop();
		};
		errorCallback = function (er) {
			if (typeof error == 'function') {
				error(er);
			}
		};
		if (isGeolocation()) {
			//loading.start();
			getCurrentPosition();
		}
	}
	function isGeolocation() {
		if (!navigator.geolocation) {
			modal.alert('Przepraszamy, Twoja przeglądarka nie wspiera Geo Services');
			return false;
		} else {
			return true;
		}
	}
	function getCurrentPosition() {
		navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, options);
	}
	function geolocationError(error) {
		let header = '';
		let text = '';
		if (options.enableHighAccuracy) {
			options.enableHighAccuracy = false;
			getCurrentPosition();
		} else {
			//loading.stop();
			switch (error.code) {
				case error.TIMEOUT:
					header = 'Czas na określenie lokalizacji został przekroczony';
					text = 'Bez zgody na lokalizację nie możemy wyświetlić pozycji najbliżej Ciebie.Możesz odlokować dostęp do lokalizacjiw ustawieniach przeglądarki Twojego urządzenia.';
					break;
				case error.POSITION_UNAVAILABLE:
					header = 'Określenie pozycji jest niemożliwe.';
					text = '';
					break;
				case error.PERMISSION_DENIED:
					header = 'Nie wyraziłeś zgody na dostęp do geolokalizacji';
					text = 'Bez zgody na lokalizację nie możemy wyświetlić pozycji najbliżej Ciebie. Możesz odlokować dostęp do lokalizacjiw ustawieniach przeglądarki Twojego urządzenia.';
					break;
				case error.UNKNOWN_ERROR:
					header = 'Nieznany błąd lokalizacji';
					text = '';
					break;
			}
			modal.generate({
				id: 'geolocation-error',
				header: header,
				content: '<p>' + text + '</p>',
				buttons: [
					{
						text: 'Rozumiem',
						click: function () {
							modal.close();
						}
					}
				]
			});
			errorCallback();
		}
	}

	return {
		findPosition
	};
});
